
export type ThingsToDoEntry = {
    id: number;
    title: string;
    content: string;
    address?: string;
    link?: string;
    linkLabel?: string;
}

let ThingsToDoEntries: ThingsToDoEntry[] = [
    {
        id: 1,
        title: "Schenley Park",
        address: "Pittsburgh, PA 15213",
        content: "Take a stroll through Schenley Park after your Phipps Conservatory visit. The park is home to landmark attractions, iconic monuments, and the best in urban recreation facilities.",
        link: "https://pittsburghparks.org/explore-your-parks/regional-parks/schenley-park/",
        linkLabel: "WEBSITE"
    },
    {
        id: 2,
        title: "Penn Brewery",
        address: "800 Vinial St,\nPittsburgh, PA 15213",
        content: "Penn Brewery, Pittsburgh's oldest brewery, is just a 3 minute drive from the WBU Event Center. Stop in as you make your way from our ceremony to reception and enjoy drinks or light bites before cocktail hour.",
        link: "https://pennbrew.com",
        linkLabel: "WEBSITE"
    },
    {
        id: 3,
        title: "De Fer Coffee & Tea",
        address: "1800 Rialto St,\nPittsburgh, PA 15212",
        content: "De Fer Coffee & Tea is a cute cafe also just minutes away from the WBU Event Center. This spot offers drinks, a full house-made food menu and a rooftop deck. Grab a coffee, sweet treat or light bite before cocktail hour. They close at 3pm, so be sure to get there before then!",
        link: "https://defer.coffee",
        linkLabel: "WEBSITE"
    }
];

export default ThingsToDoEntries;
